import { Dispatch } from 'react';
import { SuSyApi } from '../../api/susyApi';
import { ConfigActionType } from '../actionTypes/config';
import { PostDispatch } from '../types';

export const getFrontConfiguration =
    () => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.get(`/configuration/frontend`);

        dispatch({
            type: ConfigActionType.GET_FRONT_CONFIGURATION,
            payload: response.data,
        });
    };
